import { isNil } from 'lodash';
import { Editor, Element, Path, Range } from 'slate';
import { ReactEditor } from 'slate-react';

import { TableElement, TableEntry } from '../types';

/**
 * Find closest table
 *  if element/path provided, find from that point or above
 *  else if Selection is collapsed, find table contain the Selection
 *
 *
 * @param {ComposedEditor} editor
 * @param {(Element | Path)} [elementOrPath]
 * @returns  {TableEntry}
 */
export const getClosestTable = (
  editor: any,
  elementOrPath?: Element | Path
): TableEntry | undefined => {
  if (isNil(editor)) return undefined;

  if (elementOrPath) {
    return Editor.above(editor, {
      at: Path.isPath(elementOrPath)
        ? (elementOrPath as Path)
        : ReactEditor.findPath(editor, elementOrPath),
      match: (node: any) => node.type === TableElement.TABLE,
    }) as TableEntry;
  }

  if (editor.selection && Range.isCollapsed(editor.selection)) {
    return Editor.above(editor, {
      at: editor.selection.anchor,
      match: (node: any) => node.type === TableElement.TABLE,
    }) as TableEntry;
  }

  return undefined;
};
